import { Button, Descriptions, Drawer, Flex } from "antd";
import {
  DeleteOutlined,
  ReloadOutlined,
  StepForwardOutlined,
} from "@ant-design/icons";
import _ from "lodash";

import {
  DETAIL_FIELDS,
  FIELD_KEYS,
  FIELD_LABELS,
  FIELD_ORDERS,
  RESOLVE_ACTION,
} from "constants/ErrorFields";
import StatusTag from "components/Common/StatusTag";

const verticalFields = [
  FIELD_KEYS.ERROR_DETAILS,
  FIELD_KEYS.POTENTIAL_CAUSES,
  FIELD_KEYS.RECOMMENDED_ACTIONS,
];
const horizontalFieldOrders = _.intersection(
  FIELD_ORDERS,
  _.difference(DETAIL_FIELDS, verticalFields)
);
const verticalFieldOrders = _.intersection(FIELD_ORDERS, verticalFields);

const ErrorDetailsDrawer = ({
  open,
  isHistoricalView,
  data,
  loadingResolveError,
  onClose,
  onResolveError,
}) => {
  const renderField = (field, value) => {
    if (field === FIELD_KEYS.UNIT_STATUS) {
      return <StatusTag status={value} />;
    }
    if (value instanceof Array) {
      return (
        <ul style={{ margin: 0 }}>
          {value.map((val) => (
            <li>{val}</li>
          ))}
        </ul>
      );
    }
    return value ?? "-";
  };

  const resolveError = (resolveAction) => {
    onResolveError(data?.error_id, resolveAction);
  };

  return (
    <>
      <Drawer
        title="Error Details"
        placement="right"
        open={open}
        onClose={onClose}
      >
        <Descriptions column={1} labelStyle={{ fontWeight: "500" }}>
          {horizontalFieldOrders.map((field, index) => (
            <Descriptions.Item key={index} label={FIELD_LABELS[field]}>
              {renderField(field, data[field])}
            </Descriptions.Item>
          ))}
        </Descriptions>
        <Descriptions
          column={1}
          labelStyle={{ fontWeight: "500" }}
          layout="vertical"
        >
          {verticalFieldOrders.map((field, index) => (
            <Descriptions.Item
              key={index}
              label={FIELD_LABELS[field]}
              style={{ paddingBottom: 0 }}
            >
              <div style={{ paddingBottom: "1.25rem" }}>
                {renderField(field, data[field])}
              </div>
            </Descriptions.Item>
          ))}
        </Descriptions>
        {!isHistoricalView && (
          <>
            <Flex vertical={true} gap="small" style={{ paddingTop: "1.5rem" }}>
              <Button
                onClick={() => resolveError(RESOLVE_ACTION.RETRY)}
                loading={loadingResolveError}
                icon={<ReloadOutlined />}
                block={true}
              >
                Retry
              </Button>
              <Button
                onClick={() => resolveError(RESOLVE_ACTION.SKIP_PROCESS)}
                loading={loadingResolveError}
                disabled={true}
                icon={<StepForwardOutlined />}
                danger={true}
                block={true}
              >
                Skip Process
              </Button>
              <Button
                onClick={() => resolveError(RESOLVE_ACTION.REMOVE_UNIT)}
                loading={loadingResolveError}
                disabled={true}
                icon={<DeleteOutlined />}
                type="primary"
                danger={true}
                block={true}
              >
                Remove Unit
              </Button>
            </Flex>
          </>
        )}
      </Drawer>
    </>
  );
};

export default ErrorDetailsDrawer;
